export { flatten, isNotNullOrUndefined } from '@dustin-web/microsite-config/src/utils'

export const getPrice = (
  price: {
    priceExcludingVat: number
    priceIncludingVat: number
  },
  showInclVat: boolean
) => {
  return (showInclVat ? price?.priceIncludingVat : price?.priceExcludingVat) || 0
}

export const getOriginalPrice = (
  price: {
    originalPriceExcludingVat: number
    originalPriceIncludingVat: number
  },
  showInclVat: boolean
) => {
  return (showInclVat ? price?.originalPriceIncludingVat : price?.originalPriceExcludingVat) || 0
}

export const getRowPrice = (
  price: {
    priceExcludingVat: number
    priceIncludingVat: number
  },
  showInclVat: boolean,
  quantity: number
) => {
  return getPrice(price, showInclVat) * quantity
}

export const getOriginalRowPrice = (
  price: {
    originalPriceExcludingVat: number
    originalPriceIncludingVat: number
  },
  showInclVat: boolean,
  quantity: number
) => {
  return getOriginalPrice(price, showInclVat) * quantity
}

export const campaignBannerUrlExceptions = [
  '/shoppingcart',
  '/checkoutflow',
  '/solutions',
  '/service',
  '/superdeals',
  '/account',
  '/brands',
  '/kampanj',
  '/handelsmerken',
  '/campagnes',
  '/kampagne',
  '/kampanje',
  '/storkunder',
  '/rma',
  '/orders',
  '/event',
  '/black-friday',
]

export const blackWeekUrlExceptions = [
  '/shoppingcart',
  '/checkoutflow',
  '/solutions',
  '/service',
  '/superdeals',
  '/account',
  '/brands',
  '/kampanj',
  '/kampanja',
  '/handelsmerken',
  '/campagnes',
  '/kampagne',
  '/kampanje',
  '/storkunder',
  '/rma',
  '/orders',
  '/event',
  '/order/thanks/',
  '/login/checkoutlogin',
  '/checkoutsite',
  '/black-friday',
]
